import { useEffect, useMemo, useRef, useState } from "react";
import { useCookieContext } from "../../../contexts";
import icon from "../../../assets/image/login/icon.webp";
import SettingsDropDown from "./SettingsDropDown";
import { Overlay } from "react-bootstrap";
import NotificationMenu from "./NotificationMenu";
import { useQuery } from "hooks/useQuery";
import { TasksService } from "services/tasks";
import { SortDirection } from "services/shared-models/sharedEnums";
import { useBreadcrumb } from "contexts/breadcrumb/BreadcrumbContext";
import { useTranslation } from "react-i18next";
import "./style.scss";
import IconButton from "components/blocks/IconButton";

function Header() {
  const { t } = useTranslation("Shared");
  const { userSession, isAr } = useCookieContext();
  const { breadcrumbs, onItemInPathClicked } = useBreadcrumb();

  const overlayRef = useRef<HTMLButtonElement>(null);
  const [show, setShow] = useState(false);
 
  const { data: notifications, loading } = useQuery({
    queryFn: async () => {
      return await TasksService.getMyTasks({
        pageIndex: 0,
        pageSize: 30,
        sort: [
          {
            field: "isOpen",
            dir: SortDirection.Desc,
          },
        ],
      });
    },
    triggers: [isAr],
  });

  const hasOpenTasks = useMemo(() => {
    return notifications?.result.some((task) => !task.isOpen);
  }, [notifications]);

  return (
    <>
      <div className="header gap-4">
        <div className="right-section gap-4 w-100">
          <div className="d-flex gap-2 align-items-center">
            <div className="d-block d-sm-none">
              <IconButton
                icon="icon-burger"
                size="xl"
                variant="transparent"
                color="white"
                onClick={() => {
                  document.getElementById("side-menu-wrapper")?.classList.toggle("collapsed");
                }}
              />
            </div>
            <a className="home-link" href="/">
              <img src={icon} alt="Home Icon" className="home-icon" />
            </a>
          </div>

          <div className="d-none d-sm-block text-white">
            <span>
              {breadcrumbs.map((breadcrumb, index) => (
                <span key={index}>
                  <button
                    onClick={() => onItemInPathClicked(index)}
                    className=" btn btn-link text-white text-decoration-none"
                  >
                    {t(`Shared:${breadcrumb.localizationKey}`, breadcrumb.localizationParameters)}
                  </button>
                  {index < breadcrumbs.length - 1 && " > "}
                </span>
              ))}
            </span>
          </div>
        </div>
        <div className="center-section">
          
          <button ref={overlayRef} className="message-btn position-relative" onClick={() => setShow(!show)}>
            <span
              className={`circle position-absolute ${hasOpenTasks ? "bg-danger" : "bg-secondary"} tasks-status-circle`}
            ></span>
            <i className={"icon-bell text-white fs-24px"} />
          </button>
          <Overlay
            show={show}
            rootClose
            onHide={() => {
              setShow(false);
            }}
            placement="bottom"
            offset={[isAr ? 0 : 10, 16]}
            transition
            target={overlayRef.current}
          >
            {({
              placement: _placement,
              arrowProps: _arrowProps,
              show: _show,
              popper: _popper,
              hasDoneInitialMeasure: _hasDoneInitialMeasure,
              ...props
            }) => (
              <NotificationMenu
                {...props}
                notifications={notifications?.result}
                loading={loading}
                onClose={() => {
                  setShow(false);
                }}
              />
            )}
          </Overlay>
        </div>
        <SettingsDropDown
          userName={isAr? userSession?.arabicName : userSession?.englishName}
          userId={userSession?.id}
        />
      </div>
    </>
  );
}

export default Header;
